import React, { useCallback, useEffect } from 'react';
import { useAtomValue, useSetAtom } from 'jotai';
import ToolbarButton from '../../../../common/toolbar-button';
import SnapIcon from '../../../labelling/components/snapping/config/icon';
import useShortcut from '../../../labelling/providers/hooks/use-shortcut';
import { handleShortcutRegistrationError } from '../../../labelling/providers/utils/shortcut';
import { dispatchAtom } from '../../atoms/label-store-dispatch/dispatch';
import { EVENTS } from '../../atoms/label-store-dispatch/events';
import { snapEnabledAtom } from '../../atoms/tool-atoms';
export const SnapControl = () => {
  const snapEnabled = useAtomValue(snapEnabledAtom);
  const dispatch = useSetAtom(dispatchAtom);
  let {
    registerHotKeys
  } = useShortcut();
  const handleSnapSelect = useCallback(() => {
    dispatch({
      type: EVENTS.TOGGLE_SNAP
    });
  }, [dispatch]);
  useEffect(() => {
    const {
      errors,
      removeHotKeys
    } = registerHotKeys([{
      keys: ['Shift', 's'],
      onAction: handleSnapSelect
    }]);
    errors.forEach(error => handleShortcutRegistrationError(error));
    return () => {
      removeHotKeys();
    };
  }, [handleSnapSelect, registerHotKeys]);
  return <ToolbarButton title="Snap" isSelected={snapEnabled} onClick={handleSnapSelect}>
      <SnapIcon title="Snap" />
    </ToolbarButton>;
};